export const ZH_TEMPLATES = {
    // 添加通用标点和连接词
    common: {
        comma: "，",
        period: "。",
        bullet: "• ",
        newline: "\n",
        brackets: {
            left: "（",
            right: "）"
        },
        statistics: {
            mean: "均值",
            median: "中位数",
            mode: "众数",
            stdDev: "标准差",
            range: "范围"
        },
        conjunction: {
            and: "且",
            with: "与",
            forms: "形成"
        }
    },

    // 区域前缀模板
    prefixes: {
        global: "整体",
        area: " 区域"
    },

    // 基础映射
    mappings: {
        brightness: {
            BRIGHT: "偏亮",
            DARK: "偏暗",
            NEUTRAL: "中间调"
        },
        range: {
            COMPLETE: "完整",
            PARTIAL: "较完整",
            LIMITED: "有限"
        },
        tone: {
            STRONG_GREEN: "明显偏绿",
            SLIGHT_GREEN: "轻微偏绿",
            GREEN: "偏绿",
            NEUTRAL: "中性",
            RED: "偏红",
            SLIGHT_RED: "轻微偏红",
            STRONG_RED: "明显偏红"
        },
        temperature: {
            STRONG_BLUE: "明显偏蓝",
            SLIGHT_BLUE: "轻微偏蓝",
            BLUE: "偏蓝",
            NEUTRAL: "中性",
            YELLOW: "偏黄",
            SLIGHT_YELLOW: "轻微偏黄",
            STRONG_YELLOW: "明显偏黄"
        },
        intensity: {
            STRONG: "强烈",
            MODERATE: "适中",
            WEAK: "较弱"
        },
        distribution: {
            CONCENTRATED: "集中",
            SCATTERED: "较分散",
            VERY_SCATTERED: "非常分散"
        },
        skewness: {
            DARK_BIASED: "偏向暗部",
            LIGHT_BIASED: "偏向亮部",
            BALANCED: "均衡"
        },
        kurtosis: {
            CONCENTRATED: "较集中",
            GENTLE: "较平缓",
            FLAT: "平缓"
        },
        colors: {
            red: "红色区域",
            yellow: "黄色区域",
            green: "绿色点缀",
            blue: "蓝色点缀"
        },
        channels: {
            a: "a",
            b: "b",
            L: "L"
        },
        // 添加分区名称映射
        partitions: {
            blacks: "暗部",
            shadows: "阴影",
            midtones: "中间调",
            highlights: "高光",
            whites: "亮部"
        }
    },

    // 亮度模板
    brightness: {
        rules: {
            // 基本亮度规则模板
            basicBrightness: {
                darkComplete: "整体画面偏暗但层次丰富，动态范围完整",
                darkLimited: "整体画面偏暗，动态范围较为集中",
                darkPartial: "整体画面偏暗，动态范围较窄",
                brightComplete: "整体画面明亮且层次丰富，动态范围完整",
                brightLimited: "整体画面明亮，动态范围较为集中",
                brightPartial: "整体画面明亮，动态范围较窄",
                neutralComplete: "整体画面亮度适中，动态范围完整",
                neutralLimited: "整体画面亮度适中，动态范围较为集中",
                neutralPartial: "整体画面亮度适中，动态范围较窄"
            },
    
            // 特征规则模板
            featureDescriptions: {
                highContrast: "画面呈现强烈的明暗对比",
                lowKey: "低调氛围明显，以暗部为主",
                highKey: "高调氛围明显，以亮部为主"
            },
            // 细节描述模板
            detailDescriptions: {
                richShadowDetail: "暗部层次丰富完整",
                wellControlledHighlight: "亮部细节保留充分"
            },
    
            // 添加规则匹配提示
            warnings: {
                noRuleMatched: "未匹配任何规则",
                templateMissing: "模板缺失: ${rule}"
            }
        },
        description: {
            template: "${bullet}图像整体亮度${brightnessLevel}，动态范围${rangeLevel}，分布${skewnessClass}${and}${kurtosisClass}${bracketLeft}${channelL}，${mean} ${meanValue}，${median} ${medianValue}，${range} ${rangeValue}${bracketRight}${period}"
        },
        // 添加亮度分析模板
        analysis: {
            noData: "画面亮度数据不完整",
            noFeature: "画面亮度特征不明显",
            noBasicFeature: "亮度基本特征不明显",
            conclusion: {
                // 结论拼接模板
                basicFeature: "${feature}",
                withFeatureRule: "${basic}。${feature}",
                withDetailRule: "${previous}。${detail}",
                separator: "，"
            }
        }
    },
    // 色调模板
    tones: {
        rules: {
            // 分区分析色调模板
            mainTone: {
                toneSTRONG_GREEN: "主色调明显偏绿",
                toneSLIGHT_GREEN: "主色调轻微偏绿",
                toneGREEN: "主色调偏绿",
                toneNEUTRAL: "主色调中性",
                toneRED: "主色调偏红",
                toneSLIGHT_RED: "主色调轻微偏红",
                toneSTRONG_RED: "主色调明显偏红"
            },
            toneRange: {
                toneRangeConcentrated: "色调范围集中",
                toneRangeScattered: "色调分布较分散，画面层次感有所增强",
                toneRangeVeryScattered: "色调分布非常分散，画面表现复杂且多样化"
            },
            toneStability: {
                toneStable: "色调偏向稳定，整体色调一致",
                localWarmHighlight: "局部红色高值显著拉高了整体基调，增强了画面的暖色倾向",
                localCoolShadow: "低值绿色像素明显拉低了整体基调，使得局部表现出与主色调不同的冷色倾向",
                localToneDiversity: "主色调之外，画面中红绿色的局部分布差异增加了色调的多样性和层次感"
            },
            toneIntensity: {
                intensityStrong: "色调倾向强烈",
                intensityModerate: "色调倾向适中",
                intensityWeak: "色调倾向较弱"
            },
            toneDeviation: {
                deviationWeak: "主体表现接近中性",
                deviationModerate: "整体画面表现均衡",
                deviationStrong: "画面基调鲜明"
            },
        },
        overallAnalysis: {
            consistency: {
                OVERALL_CONSISTENCY: "各区域呈现较为统一的色调倾向"
            },
            variations: {
                OVERALL_VARIATIONS: "局部分区呈现色调差异"
            },
            contrast: {
                SHADOW_HIGHLIGHT_CONTRAST: "阴影部分与高光部分形成鲜明的色调对比"
            }
        },

        // 添加色调分析模板
        analysis: {
            noData: "画面色调特征不明显",
            noRules: "画面色调特征不明显",
            conclusion: {
                // 结论拼接模板
                separator: "，",
                period: "。",
                partitionVariation: "其中${descriptions}",
                partitionTone: {
                    strong: "明显",
                    moderate: "轻微",
                    red: "偏红",
                    green: "偏绿",
                    neutral: "接近中性"
                }
            }
        }
    },
    temperature: {
        distribution: {
            balanced: "色温分布平衡",
            contrastive: "冷暖对比明显",
            gradual: "色温渐变自然",
            warmDominant: "暖色调主导",
            coolDominant: "冷色调主导",
            neutralBalanced: "冷暖平衡协调"
        },
        zoneContrast: {
            shadowsWarm: "暗部偏暖",
            highlightsCool: "高光偏冷",
            midtonesNeutral: "中间调中性",
            shadowsCool: "暗部偏冷",
            highlightsWarm: "高光偏暖",
            gradualTransition: "色温过渡自然",
            strongContrast: "冷暖对比强烈"
        },
        rules: {
            // 分区分析色温模板
            tone: {
                toneSTRONG_BLUE: "色温明显偏蓝",
                toneSLIGHT_BLUE: "色温轻微偏蓝",
                toneBLUE: "色温偏蓝",
                toneNEUTRAL: "色温中性",
                toneYELLOW: "色温偏黄",
                toneSLIGHT_YELLOW: "色温轻微偏黄",
                toneSTRONG_YELLOW: "色温明显偏黄"
            },
            intensity: {
                intensityStrong: "倾向强烈",
                intensityModerate: "倾向适中",
                intensityWeak: "倾向较弱"
            },
            stability: {
                stabilityStable: "分布集中，色温稳定",
                stabilityDominantCool: "冷色占据主导，蓝色像素分布集中",
                stabilityWarmHighlights: "但少量暖色高值像素拉高均值，画面略显暖意",
                stabilityCoolWithWarmInfluence: "整体冷色占多数，但暖色高值像素影响显著，形成局部暖意",
                stabilityWarmWithCoolContrast: "整体感知偏暖色，但偏蓝区域的存在形成冷暖对比",
                stabilityBalancedContrast: "色彩分布相对均匀，存在一定冷暖对比",
                stabilityUniform: "色彩分布均匀一致"
            },
            deviation: {
                'DEVIATION_WEAK': '画面表现接近中性',
                'DEVIATION_MODERATE': '画面层次感丰富',
                'DEVIATION_STRONG': '画面基调鲜明'
            }
        },
        overallAnalysis: {
            consistency: {
                OVERALL_TEMP_CONSISTENCY: "各区域呈现较为统一的冷暖倾向"
            },
            variations: {
                OVERALL_TEMP_VARIATIONS: "局部分区呈现差异化冷暖变化，增加了画面的层次感"
            },
            contrast: {
                SHADOW_HIGHLIGHT_TEMP_CONTRAST: "明暗分区的色温形成鲜明对比，丰富了画面的冷暖关系"
            }
        },
        // 添加色温分析模板
        analysis: {
            noData: "画面色温特征不明显",
            noRules: "画面色温特征不明显",
            prefix: "整体",
            conclusion: {
                // 结论拼接模板
                separator: "，",
                period: "。",
                partitionVariation: "其中${descriptions}",
                partitionTemp: {
                    strong: "明显",
                    moderate: "轻微",
                    warm: "偏暖",
                    cool: "偏冷",
                    neutral: "接近中性"
                }
            }
        }
    },
    // 添加统计描述模板
    statistics: {
        L: "L通道",
        a: "a 通道",
        b: "b 通道",
        mean: "平均值",
        median: "中位数",
        mode: "众数",
        stdDev: "标准差",
        range: "范围"
    },

    // 添加不完整数据提示
    incomplete: {
        mainTone: "主色调数据不完整",
        colorTemperature: "色温数据不完整"
    },

    // 添加局部色彩描述模板
    localColor: {
        description: {
            both: "局部存在明显的${highlights}，并同时存在显著的${lowlights}，增强了画面的色彩层次感",
            highlights: "局部存在明显的${highlights}，与主色调形成对比补充",
            lowlights: "局部存在显著的${lowlights}，与主色调形成对比补充",
            balanced: "高值像素和低值像素分布均匀，整体色彩较均衡",
            colorFormat: "${color}（${channel} 通道最大值 ${value}）"
        }
    },

    // 添加文本格式模板
    format: {
        doubleNewline: "\n\n",
        singleNewline: "\n",
        globalConclusion: {
            template: "${brightness}${doubleNewline}${mainTone}${singleNewline}${temperature}${doubleNewline}${localColor}"
        },
        partitionConclusion: {
            template: "${mainTone}${singleNewline}${temperature}${doubleNewline}${localColor}"
        }
    }
}; 